var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgL8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 340,
    height: 22,
    viewBox: "0 0 340 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0197 18.88L20.3997 21.26L30.9297 10.72L20.2197 -4.6815e-07L17.8397 2.38L26.1797 10.72L18.0197 18.88ZM6.97974 21.26L4.59973 18.88L12.7598 10.72L4.41974 2.38L6.79974 -1.05475e-06L17.5098 10.72L6.97974 21.26ZM-6.44037 21.26L-8.82037 18.88L-0.66034 10.72L-9.00037 2.38L-6.62036 -1.64136e-06L4.09961 10.72L-6.44037 21.26Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgL8);
export default __webpack_public_path__ + "static/media/l8.7ec259f7c4f69d38581fe235e445b765.svg";
export { ForwardRef as ReactComponent };